module.exports = __webpack_public_path__ + "static/media/closedeye.925f0cbf.svg";